import { Component, OnInit } from '@angular/core';
import { BarcodeServiceService } from './common/barcode/barcode-service.service';
import { RouteUtilService } from './shared/utils/route-util.service';
import { BarcodeReader } from './common/barcode/barcode-reader';
import { Router } from '@angular/router';
import { CacheConstant } from './core/cache/cache.constant';
import { SessionStorageService } from 'ngx-webstorage';
import { IdleSessionService } from './core/services/idle-session.service';
import { Environment } from './core/environment/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  barcodeReader = new BarcodeReader();
  capturedBarcodeText = "";
  keyControl = false;
  idleTimeOutInSec: number;
  nucbotAuthToken: string;
constructor(private routeUtils: RouteUtilService,
  private router:Router,
  private barcodeService:BarcodeServiceService,
  private idleSessionService: IdleSessionService,
  private storage: SessionStorageService,
  ){
}

  ngOnInit() {
    if(window.location.pathname=== '/'){
      this.routeUtils.navigate('home');
    }
    this.setBarcodeListener();

    const raw = (Environment.getInstance().appConfig as any)['idleTimeoutInSec'];
    const parsed = Number(raw);
    this.idleTimeOutInSec = Number.isFinite(parsed) ? parsed : undefined;
    if (Number.isFinite(this.idleTimeOutInSec) && this.idleTimeOutInSec > 0) {
      this.idleSessionService.initialize(this.idleTimeOutInSec, 0);
    } else {
      console.error('idleTimeOutInSec is missing/invalid in env config; idle logout was not initialized.');
    }

    this.nucbotAuthToken = this.storage.retrieve(CacheConstant.SessionStorageData.AuthenticationToken);
  }

  private setBarcodeListener() {
    document.addEventListener('keypress', (event) => {
      let response = this.barcodeKeypress(event);
      if (response) {

        this.barcodeService.barcodeData.next(response);
      }
    });
  }


  private barcodeKeypress(event) {
    var res = null;
    if (this.keyControl && event.which === 92) {
      event.preventDefault();
      this.keyControl = false;
      res = this.barcodeReader.decode(this.capturedBarcodeText);
      this.capturedBarcodeText = '';
    } else if (this.keyControl) {
      event.preventDefault();
      this.capturedBarcodeText = this.capturedBarcodeText + event.key;
    }
    if (event.which === 126) {
      event.preventDefault();
      this.keyControl = true;
    }
    return res;
  }
}
